import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDownSharpIcon from '@material-ui/icons/KeyboardArrowDownSharp';
import { TextField, Select, MenuItem } from '@material-ui/core';

import c from 'classnames';
import Benchmarks from '../../../components/FilterBar/Benchmarks';
import CircleClose from '../assets/CircleClose.svg';
import InfoLarge from '../../Analytics/assets/DisclaimerWarning1.svg';
import { getStaticText } from '../../../utils/constants';
import { getPsOhiExLabel } from '../reportPublicSector';

function AdditionalSurvey({
    benchState,
    additionalSettings,
    handleAdditionalChange,
    handleBenchState,
    reportName,
    surveyType,
    index,
    projects,
    removeSection,
    currentOhid,
    reportApiParams,
    defaultSettings,
    showBulk,
    exBenchState,
    handleExBenchState,
    compYrSettings,
}) {
    const { options: opt } = reportApiParams;
    const { ReportType } = opt;
    const {
        lang,
        apply_employee_exp_benchmark = false,
        report_type: surveyTypeName = '',
        is_public_sector_ohi = false,
    } = defaultSettings;
    const { compYrSettings: settings = {}, settingsFetched = false } = compYrSettings[`compYr${index}`] || {};
    const { apply_employee_exp_benchmark: compYrApplyExBm = false } = settings || {};
    const staticText = getStaticText(lang);
    const { SITE_TEXT } = staticText;
    const {
        BENCHMARK_QUARTILE_COLOR,
        SUB_INFO_GENERAL,
        ADDITIONAL_SURVEY,
        PREVIOUS_SURVEY,
        REMOVE,
        ENTER_REPORT_NAME,
        SELECT_SURVEY,
        ENTER_NAME,
        BENCHMARK_QUARTILE_COLOR_EX,
        SUB_INFO_EX_GENERAL,
        EX_REPORT_NO_BM,
        EX_REPORT_BOTH_NO_BM,
        ADDITIONAL_PRACTICES,
    } = SITE_TEXT || {};
    const mapPsOhiEx = text => getPsOhiExLabel(is_public_sector_ohi, ReportType, text, ADDITIONAL_PRACTICES);
    const indexToUse = index + 1;
    const benchArr = benchState[indexToUse] || [];
    const exBenchArr = exBenchState[indexToUse] || [];

    const getWarnText = () => {
        if (apply_employee_exp_benchmark && !compYrApplyExBm) {
            return mapPsOhiEx(EX_REPORT_NO_BM);
        }

        if (!apply_employee_exp_benchmark && !compYrApplyExBm) {
            return mapPsOhiEx(EX_REPORT_BOTH_NO_BM);
        }

        return null;
    };

    const warnText = getWarnText();

    const filterProject = React.useMemo(() => {
        const allSurveys = [currentOhid];
        additionalSettings.forEach(({ surveyType: selectedSurveyType }, mainIndex) => {
            if (mainIndex !== index && selectedSurveyType) {
                const excluseOhid = selectedSurveyType.split('+')[0] || '';
                if (excluseOhid) {
                    allSurveys.push(excluseOhid);
                }
            }
        });
        return projects.filter(({ ohid }) => !allSurveys.includes(ohid));
        // eslint-disable-next-line
    }, [additionalSettings, index]);

    const getProjectList = projectArr => {
        return projectArr.map(({ benchmark_version_id, ohid, year, survey_name }) => {
            return (
                <MenuItem
                    data-testid="lang-option"
                    classes={{ root: 'demographicOptions' }}
                    key={ohid}
                    value={`${ohid}+${benchmark_version_id}+${year}`}
                >
                    {ohid} - {year} ({survey_name})
                </MenuItem>
            );
        });
    };
    return (
        <section className="sectionContent">
            <div className="surveyHeading subHeading">
                <span>{ReportType === '3' ? ADDITIONAL_SURVEY : PREVIOUS_SURVEY}</span>
                {additionalSettings.length > 1 && (
                    <div className="remove" onClick={e => removeSection(e, index)}>
                        <div>
                            <img src={CircleClose} alt="" />
                        </div>
                        <div>{REMOVE}</div>
                    </div>
                )}
            </div>

            <div className="generalSettingWrapper">
                {!showBulk && (
                    <div className="settingContent">
                        <span className="title">{ENTER_REPORT_NAME}</span>
                        <TextField
                            autoComplete="false"
                            name="reportName"
                            value={reportName}
                            onChange={e => handleAdditionalChange(e, index)}
                            placeholder={ENTER_NAME}
                            className={c('surveyTypeContent', { demoSurveyContent: reportName })}
                            data-testid="reportName"
                        />
                    </div>
                )}
                <div className="settingContent">
                    <span className="title">{SELECT_SURVEY}</span>
                    <Select
                        IconComponent={KeyboardArrowDownSharpIcon}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="surveyType"
                        data-testid="surveyType"
                        value={surveyType}
                        className={c('surveyTypeContent', { demoSurveyContent: surveyType })}
                        displayEmpty
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                        }}
                        onChange={e => handleAdditionalChange(e, index)}
                    >
                        <MenuItem value="" classes={{ root: 'demographicOptions' }}>
                            {SELECT_SURVEY}
                        </MenuItem>
                        {getProjectList(filterProject)}
                    </Select>
                </div>
            </div>

            {benchArr.length && surveyType && ReportType < 4 ? (
                <div className="gnLowerWrapper">
                    <div className="title">{BENCHMARK_QUARTILE_COLOR}</div>
                    <div className="subInfo textInfo">{SUB_INFO_GENERAL}</div>
                    <div className="rightSideFilters additionalSurvey benchContent">
                        <Benchmarks
                            defaultSettings={defaultSettings}
                            showHeader={false}
                            benchmarks={benchArr}
                            updateBenchmarks={updatedBenchmarks => handleBenchState(updatedBenchmarks, indexToUse)}
                        />
                    </div>
                </div>
            ) : null}
            {surveyType && ReportType < 4 ? (
                <div className="gnLowerWrapper">
                    <div className="title">{mapPsOhiEx(BENCHMARK_QUARTILE_COLOR_EX)}</div>
                    <div className="subInfo textInfo">{mapPsOhiEx(SUB_INFO_EX_GENERAL)}</div>
                    <div className="rightSideFilters benchContent">
                        {compYrApplyExBm && settingsFetched ? (
                            <Fragment>
                                {exBenchArr.length ? (
                                    <Benchmarks
                                        showHeader={false}
                                        benchmarks={exBenchArr}
                                        defaultSettings={defaultSettings}
                                        updateBenchmarks={updatedBenchmarks =>
                                            handleExBenchState(updatedBenchmarks, indexToUse)
                                        }
                                    />
                                ) : null}
                            </Fragment>
                        ) : null}
                        {warnText !== null && surveyTypeName !== 'percent favorable' && (
                            <div className="noMapDemo exInfo">
                                <span>
                                    <img src={InfoLarge} alt="warning" />
                                </span>
                                {warnText}
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </section>
    );
}

AdditionalSurvey.defaultProps = {
    compYrSettings: {},
    exBenchState: [],
};

AdditionalSurvey.propTypes = {
    additionalSettings: PropTypes.array.isRequired,
    handleAdditionalChange: PropTypes.func.isRequired,
    handleBenchState: PropTypes.func.isRequired,
    reportName: PropTypes.string.isRequired,
    surveyType: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    projects: PropTypes.array.isRequired,
    benchState: PropTypes.array.isRequired,
    removeSection: PropTypes.func.isRequired,
    currentOhid: PropTypes.string.isRequired,
    reportApiParams: PropTypes.object.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    showBulk: PropTypes.bool.isRequired,
    exBenchState: PropTypes.array,
    handleExBenchState: PropTypes.func.isRequired,
    compYrSettings: PropTypes.object,
};
export default AdditionalSurvey;
